import Recorder from './recorder';

export default class AudioRecorder extends Recorder{
  constructor(instance, path, nicePath) {
    super(instance, path, nicePath);
    this._icons.recording = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23FF0000' d='M12,2A3,3 0 0,1 15,5V11A3,3 0 0,1 12,14A3,3 0 0,1 9,11V5A3,3 0 0,1 12,2M19,11C19,14.53 16.39,17.44 13,17.93V21H11V17.93C7.61,17.44 5,14.53 5,11H7A5,5 0 0,0 12,16A5,5 0 0,0 17,11H19Z' /%3E%3C/svg%3E";
  }

  getDefaults(){
    let patchNeeded = false;
    if(!this._defaults){
      patchNeeded=true;
    }

    const defaults = super.getDefaults();    
    if(patchNeeded){
      defaults.video.enabled = false;
    }

    return defaults;
  }
}